import { useState, useEffect, useRef } from 'react';

export default function OverallComments({ value, isLocked, onChange }) {
  const [text, setText]   = useState(value || '');
  const [saved, setSaved] = useState(true);
  const debounceRef       = useRef(null);

  useEffect(() => { setText(value || ''); }, [value]);

  function handleChange(e) {
    const val = e.target.value;
    setText(val);
    setSaved(false);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      onChange(val);
      setSaved(true);
    }, 800);
  }

  return (
    <div style={s.wrap}>
      <div style={s.header}>
        <div>
          <div style={s.label}>Overall DVP Comments</div>
          <div style={s.sublabel}>
            DVP summary of this month's performance, key concerns, and action items.
            Only the DVP for this cost center can edit this field.
          </div>
        </div>
        {!isLocked && (
          <span style={{ ...s.saveStatus, color: saved ? '#16A34A' : '#9CA3AF' }}>
            {saved ? '✓ Saved' : 'Saving…'}
          </span>
        )}
      </div>
      {isLocked ? (
        <div style={s.lockedText}>
          {text || <em style={{ color: '#D1D5DB' }}>No overall comment was added.</em>}
        </div>
      ) : (
        <textarea
          style={s.textarea}
          rows={4}
          value={text}
          onChange={handleChange}
          placeholder="Enter overall comments for this review period…"
          maxLength={5000}
        />
      )}
      {!isLocked && (
        <div style={s.charCount}>{text.length} / 5,000</div>
      )}
    </div>
  );
}

const s = {
  wrap: {
    background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: '10px',
    padding: '18px 20px', marginTop: '16px', marginBottom: '8px',
  },
  header:    { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' },
  label:     { fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.5px', color: '#6B7280', marginBottom: '3px' },
  sublabel:  { fontSize: '12px', color: '#9CA3AF' },
  saveStatus:{ fontSize: '11px', fontWeight: 500, flexShrink: 0 },
  textarea: {
    width: '100%', border: '1px solid #D1D5DB', borderRadius: '8px',
    padding: '10px 12px', fontSize: '13px', color: '#374151', background: '#fff',
    fontFamily: 'inherit', resize: 'vertical', minHeight: '80px', lineHeight: 1.6,
  },
  lockedText: { fontSize: '13px', color: '#374151', lineHeight: 1.6, background: '#fff', borderRadius: '8px', padding: '10px 12px', border: '1px solid #E5E7EB' },
  charCount:  { fontSize: '10px', color: '#D1D5DB', textAlign: 'right', marginTop: '4px' },
};
